const state = {
   batchUnload:{},
}

export default state
